import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { Image } from '@inter-ikea-kompis/component-image';

/**
 * SheetBody component.
 */

export default class SheetBody extends KompisElement {
	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	// Adds a vertical scroll-bar that will always be visible.
	@property({ type: Boolean })
	public verticalScroll = false;

	// Separates the header and body with a thin line that acts like a divider.
	@property({ type: Boolean })
	public scrollDivider = false;
	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		return html`
			<style>
				:host {
					flex-grow: 1;
					display: block;
					overflow-y: ${this.verticalScroll ? 'scroll' : 'auto'};
					border-top: ${this.scrollDivider
						? `${1 / 16}rem solid ${this.theme.color.border.default}`
						: 'none'};
				}
			</style>
			<slot></slot>
		`;
	}

	public override connectedCallback(): void {
		this.customElements.define('kompis-image', Image);

		super.connectedCallback();
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-sheet-body': SheetBody;
	}
}
